import React from 'react';
import { Progress, Row, Col, Card } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import moment from 'moment';
import {
  KPITitleText,
  KpiSubText,
  KpiFlightDate,
} from '../../../../../../shared/globalStyling/styledText';
import { formatWholeNumber } from '../../../../../../../core/utils/campaigns';

const styles = {
  container: {
    backgroundColor: '#fff',
    borderTop: 'solid 1px #e8e8e8',
    marginBottom: '1%',
  },
  title: {
    marginBottom: '10px',
  },
  datesContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  dates: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
};

const TopBar = ({ startDate, endDate, totalSignups }) => {
  const getProgress = () => {
    const total = () => {
      const a = moment(endDate);
      const b = moment(startDate);
      return a.diff(b, 'days');
    };

    const progress = () => {
      const a = moment();
      const b = moment(startDate);
      return a.diff(b, 'days');
    };

    const totaldays = total();
    const progressDays = progress();

    // Handle edge cases: zero duration campaigns or campaign hasn't started yet
    if (totaldays <= 0) {
      return 0; // Campaign has no duration
    }

    if (progressDays <= 0) {
      return 0; // Campaign hasn't started yet
    }

    if (progressDays >= totaldays) {
      return 100; // Campaign is complete or past end date
    }

    const daysleft = totaldays - progressDays;
    const daysin = totaldays - daysleft;
    const result = (daysin / totaldays) * 100;
    return Math.floor(result);
  };

  const currentposition = getProgress();

  return (
    <Row style={styles.container} gutter={12}>
      <Col flex="1 1 200px">
        <Card
          style={{
            height: '10em',
            borderLeft: 0,
            borderTop: 0,
          }}
          bodyStyle={{ borderLeft: 0 }}
        >
          <div style={styles.title}>
            <KPITitleText text={'Flight Dates'} />
          </div>
          <div style={styles.datesContainer}>
            <div style={styles.dates}>
              <KpiFlightDate text={`${moment(startDate).format('MM/DD/YYYY')}`} />
            </div>
            <div>
              <ArrowRightOutlined style={{ color: '#636363' }} />
            </div>
            <div style={styles.dates}>
              <KpiFlightDate text={`${moment(endDate).format('MM/DD/YYYY')}`} />
            </div>
          </div>
          <Progress
            showInfo={false}
            percent={currentposition}
            status={currentposition !== 100 ? 'active' : 'normal'}
            strokeColor={'#636363'}
          />
        </Card>
      </Col>
      <Col flex="1 1 200px">
        <Card style={{ height: '10em', borderLeft: 0, borderTop: 0 }} bodyStyle={{ borderLeft: 0 }}>
          <div style={styles.title}>
            <KPITitleText text={'Sign Ups'} />
          </div>
          <KpiSubText text={`${formatWholeNumber(totalSignups || 0)}`} />
        </Card>
      </Col>
    </Row>
  );
};

export default TopBar;
